export { default as SquareCombinedSolidIcon } from './SquareCombinedSolidIcon';
